import { Platform } from '@angular/cdk/platform';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Logo } from '../../../components/common/logo/logo';
import {
  UserPaymentIntent,
  UserPaymentIntentStatus,
} from '../../../models/shopping';
import { ShoppingApiService } from '../../../services/apis/shopping-api.service';
import { CartService } from '../../../services/cart.service';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-checkout-result-page',
  imports: [
    MatProgressSpinnerModule,
    MatButtonModule,
    RouterModule,
    Logo,
    MatIconModule,
  ],
  templateUrl: './checkout-result-page.html',
  styleUrl: './checkout-result-page.scss',
})
export class CheckoutResultPage {
  payment_intent_id: string = '';
  redirect_status: string = '';
  loading: boolean = false;
  user_payment_intent?: UserPaymentIntent;
  constructor(
    private shoppingApi: ShoppingApiService,
    private route: ActivatedRoute,
    private platform: Platform,
    private titleService: TitleService,
    private cartService: CartService
  ) {
    this.titleService.setTitle('Payment Confirmation');
    this.route.queryParams.subscribe((params) => {
      this.payment_intent_id = params['payment_intent'] ?? '';
      this.redirect_status = params['redirect_status'] ?? '';
      this.confirmPaymentIntent();
    });
  }

  async updatePaymentSuccess() {
    this.titleService.setTitle('Thank You for Your Purchase');
    this.cartService.findShoppingCartItems(
      new Date(this.user_payment_intent!.created_at).getTime()
    );
  }

  async updatePaymentFailed() {
    this.titleService.setTitle('Payment Unsuccessful');
  }

  async updatePaymentPending() {
    this.titleService.setTitle('Payment Pending');
  }

  get isSuccessed(): boolean {
    return (
      this.user_payment_intent?.status === UserPaymentIntentStatus.Succeeded
    );
  }

  get isPending(): boolean {
    return this.user_payment_intent?.status === UserPaymentIntentStatus.Pending;
  }

  async confirmPaymentIntent() {
    try {
      this.loading = true;
      this.user_payment_intent =
        await this.shoppingApi.confirmStripePaymentIntent(
          this.payment_intent_id
        );
      if (
        this.user_payment_intent.status === UserPaymentIntentStatus.Succeeded
      ) {
        await this.updatePaymentSuccess();
      } else if (
        this.user_payment_intent.status === UserPaymentIntentStatus.Failed
      ) {
        await this.updatePaymentFailed();
      } else {
        await this.updatePaymentPending();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
